module.exports = __webpack_public_path__ + "static/media/hab6-1.54331268.jpg";